// Action
export const sagaActions = {
  FETCH_DATA_SAGA: "LoginData",
  FETCH_FOTGOT_PASSWORD_PERSON: "forgotpassword",
  FETCH_VERIFY_OTP: "OtpVerifyCall",
  FETCH_RESEND_OTP: "ResendOtp",
  FECTH_DATA_FOR_DUMMY: "TableData",
  FETCH_SHEET_BULKUPLOAD: "sheetBulkUpload",
  FETCH_EMPLOYEE_BULKUPLOAD: "employeeBulkUpload",
  FETCH_SHEET_BULKUPLOAD_GETDATA: "sheetBulkUploadGetData",
  FETCH_DENAVE_STATE_GETDATA: "denaveStateGetData",
  FETCH_EMPLOYEE_BULKUPLOAD_GETDATA: "employeeBulkUploadGetData",
  FETCH_DENAVE_BULKUPLOAD_NEW: "denaveBulkUploadNew",
  FETCH_DENAVE_BULKUPLOAD_NEW_GETDATA: "denaveBulkUploadNewGetData",
  FETCH_SONY_BULKUPLOAD: "sonyBulkUpload",
  FETCH_SONY_BULKUPLOAD_GETDATA: "sonyBulkUploadGetData",
  FETCH_UPDATE_PASSWORD_: "UpdatePassword",
  FETCH_ROLE_LIST_TABLE: "RoleLists",
  FETCH_ROLE_CREAT_LIST: "roleCreates",
  FETCH_ROLE_DELTE_CALLS_: "roleDeleteCal",
  FECTH_ROLE_RETRIRVE_CALL: "roleRrieve",
  FECTH_ROLE_EDIT_CALLS: "RoleEditsCalls",
  FETCH_USER_GET_LIST: "UserSlice",
  FETCH_USER_DELETECALL: "UserDeleteCall",
  FETCH_USER_CREATE_DATA: "userCreate",
  FETCH_USER_RETRIEVE_DATA: "UserRetrieve",
  FETCH_USER_EDIT_DATA: "UserEdits",
  FETCH_GEO_LOCATIONS: "GeoState",
  FECTH_STATE_CREATE_ACTIONS: "stateCreate",
  FETCH_STATE_DELETE_ACTIONS: "StateDelete",
  FETCH_STATE_EDIT_ACIONS: "StateEdit",
  FETCH_STATE_RETRIEVE_ACTIONS: "StateRetrieve",
  FETCH_REGION_LIST_ACTIONS: "regioncall",
  FETCH_REGION_CREATE_LIST: "regioncreate",
  FETCH_REGION_DELETE_CALL: "RegionDelete",
  FETCH_REGION_RETRIRVE_ALL: "RegionRetrieve",
  FETCH_REGION_EDIT_CALL: "RegionEditCalls",
  FETCH_ZONE_LISTS: "ZonePart",
  FETCH_ZONE_CREATE: "ZoneCreate",
  FETCH_ZONE_EEDIT_CALL: "ZoneEditCalls",
  FETCH_ZONE_RETRIEVE_CALL: "ZoneRetrieve",
  FETCH_ZONE_DELETE_CALL: "ZoneDelete",
  FETCH_CLIENT_GET_LISTS: "ClientList",
  FETCH_CLIENT_CREATE_POST: "ClientCreate",
  FETCH_CLIENT_DELETE_DEL: "ClientDeletes",
  FETCH_CLIENT_RETRIEVE_LIST: "ClientRetrieves",
  FECTCH_CLIENT_EDIT_LIST: "ClientEditCalls",
  FETCH_CLIENT_BRANCHES_LIST_: "ClientBranch",
  FETCH_CLIENT_BRANCHES_CREATE_: "ClientBranchCreate",
  FETCH_CLIENT_BRANCHES_DELETE_CALLS: "ClientBranchDeleteCall",
  FETCH_BRANCHES_RETRIEVE_DATA: "BranchRetrieveDATA",
  FETCH_BRANCHES_EDIT_CALL: "BranchEdits",
  FETCH_BRANCHSEARCH_LIST: "BranchSearchpart",
  FETCH_SHIFT_CALL_TABLE: "ShiftList",
  FETCH_SHIFT_CALL_DELETE: "ShiftDelete",
  FETCH_SHIFT_SEARCH_CALL_TABLE: "ShiftSearch",
  FETCH_SHIOFT_CREATE_CALL: "shiftCreate",
  FETCH_SHIFT_EDIT_CALL: "ShiftEdits",
  FETCH_SHIFT_RETRIEVE_CALL: "ShiftRetrieveData",
  FETCH_EMPLOYEE_LIST_CALL: "EmployeeList",
  FETCH_EMPLOYEE_CREATE_CALL: "EmployeeCreate",
  FETCH_EMPLOYEE_DELETE_CALL: "EmployeeDelete",
  FETCH_EMPLOYEE_RETRIEVE_CALL: "EmployeeRetrieve",
  FETCH_EMPLOYEE_EDIT_CALL: "EmployeeEditsCalls",
  FETCH_EMPLOYEE_DATA_LIST_CALL: "EmployeeDATASList",
  FETCH_EMPLOYEE_DATA_PERSONS_LISTED_CALLS: "EmployeeListPresons",
  FETCH_EMPLOYEE_DETAIL_PROFILE_LIST: "EmployeeProfile",
  FETCH_FORMS_DETAILS_BASIC_FORM: "FormsSDETAILS",
  FETCH_FORMS_DETAILS_ADDRESS_FORM: "AddressForms",
  FETCH_IDVERIFICATION_DETAILS_FORMS: "IdverificationName",
  FETCH_BANKDETIAL_DATA_FORM: "BankDetails",
  FETCH_EDUCATION_DATA_FORMS: "EducationAction",
  FETCH_PREVIOUS_EMPLOYEE_DETAILS: "PreviousEmp",
  FETCH_FAMILY_DETAILS_EMPLOYEEE: "FamilyList",
  FETCH_DECALARATION_FORM_DATAS: "DeclarationCall",
  FETCH_DETAILS_FROM_ESI_FORM: "ESIdetails",
  FETCH_DAETAILS_FORM_JOB_OFFERDETAILS: "JOBOfferCall",
  FETCH_ID_VERIFICATION_EDIT_CALLS: "IdVrificationEditCall",
  FETCH_FORMS_APPROVAL_DATAS: "ApprovalCall",
  FETCh_COMPLETED_AND_VEIRIFED_USERS: "VerifiedUsers",
  FETCH_JONING_DATE_GENERAT_CALL: "JoningDateCall",
  FETCH_SIGNATURE_CALL_RESPONSE_LIST: "SignatureCall",
  FETCH_USER_FILTER_RESPONSE_CALL: "UserFilterCall",
  FETCH_EMPLOYEE_LIST_FLITER_PEN_COMP_DEC_APP: "EmployeeListfilterPresons",
  FETC_SHIFT_EMPLOYEE_SHEET_EXCEL_UPLOADS: "excelsheets",
  FETCH_EXCEL_RENDER_COUNTS: "makingChanges",
  FETCH_LEAVE_TYPE_CREATE: "LeaveTypeCareteCall",
  FETCH_LEAVE_TYPE_LIST_OUTS: "LeaveTypeList",
  FETCH_LEAVE_TYPE_DELETE_CALL: "LeaveTypeDelete",
  FETCH_LEAVE_TYPE_RETRIEVE_CALL: "LeaveTypeRetrieveCall",
  FETCH_LEAVE_TYPE_EDITS_CALLS: "LeaveTypeEditCall",
  FETCH_LEAVE_PERMISSION_CALL: "LeavePremissionLists",
  FETCH_LEAVE_PERMISSION_SEARCH_CALL: "LeavePremissionSearchLists",
  FETCH_LEAVE_PERMISSION_DELETE_CALL: "LeavepermissionDeleteCall",
  FETCH_LEAVE_PERMISSION_RETRIEVE_CALLS: "LeavePermissionRetrieveCall",
  FETCH_LEAVE_PERMISSION_EDIT_CALLS: "LeavePermissionEditsCall",
  FETCH_DASHBOARD_COUNT_LIST: "DashboardCall",
  FETCH_CLIENT_SIDE_LEAVE_STATUS__LIST: "LeaveStatusListed",
  FETCH_SHIFT_EXCEL_SHEET_UPLOAD_GET_LIST: "ShfitData",
  FETCH_SHIFT_PERMISSION_LISTS: "shiftPermission",
  FETCH_SHIFT_PERMISSION_RETRIEVE: "ShiftPermissionRetrieveCall",
  FETCH_SHIFT_PERMISSION_EDITS: "ShiftPermissionEditsCall",
  FETCH_SHIFT_PERMISSION_DELETE: "ShiftpermissionDeleteCall",
  FETCH_RE_INVESTMENT_GET_LIST: "reinvestmentCall",
  FETCH_RE_INVESTMENT_RETRIVE_LIST: "reInvestmentRetrieveCall",
  FETCH_RE_INVESTMENT_EDIT_LIST: "ReinvestmentEditCall",
  FETCH_SHIFT_EXCEL_RETRIEVE_LIST: "ShifteexcelshettRetriev",
  FETCH_ON_DUTY_GET_LIST_RESPONSER: "OndutyCalls",
  FETCH_ON_DUTY_GET_LIST_RETRIEVE: "onDutyRetrieveCall",
  FETCH_ON_DUTY_EDIT_REPONSES: "OnDutyEditsCall",
  FETCH_ON_DUTY_DELETED: "OnDutyDeleteCall",
  FETCH_RESIGN_GET_LIST: "resignCall",
  FETCH_RESIGN_RETRIEVE_LIST: "ResignRetrieveCall",
  FETCH_RESIGN_EDIT_LISTS: "ResignEditsCall",
  FETCH_RESIGN_DELETE_CALL: "ResignDeleteCall",
  FETCH_EXIT_ALL_DATA: "ExitCall",
  FETCH_EXIT_RETIEVE_LIST_DATAS: "ExitRetrieveCall",
  FETCH_EXIT_EXIT_LIST_DATAS: "ExitEditsCall",
  FETCH_EXIT_DELETE_DATAS: "ExitDeleteCall",
  FETCH_UPDATE_NODUE_FORM: "ExitNodueEditCall",
  FETCH_APPAISAL_DATA: "AppraisliceCall",
  FETCH_APPRAISAL_RETRIEVE_DATA: "AppraisalRetrieveCall",
  FETCH_APPRAISAL_EDITS: "AppraisalEditCall",
  FETCH_PAY_SLIP_DATA: "payslip",
  FETCH_PAY_SLIP_CREATE: "payslipCreate",
  FETCH_PAY_SLIP_RETRIEV: "payslipRetrieve",
  FETCH_PAY_SLIP_EDIT: "payslipEdit",
  FETCH_FIELD_AGENT_BRANC_LIST_OUT: "fieldagentBracnhdata",
  FETCH_BASIC_FORM_CREATE: "BasicFormCreated",
  FETCH_ADDRESS_CREATE: "AddressCraeteForms",
  FETCH_JOB_OFFER_CREATE_FOMR: "JOBOfferCreateCall",
  FETCH_JOB_OFFER_PREVIEW: "JOBOfferPreviewCall",
  FETCH_REMAINDER_EMAIL: "RemainderMailCall",
  FETCH_FORM_ACTIONIONCALL_BANK_DETAILS: "BankcreateDetails",
  FETCH_FORM_ACTIONCALL_EDUCATION: "EducationcreateAction",
  FTCH_EMPLOYEE_LIST_FOR__MANGER: "EmployeeListManagerPresons",
  FETCH_BASIC_FORM_EDITS: "BasicFormEdit",
  FETCH_ADDRESS_EDITS: "AddressEditorms",
  FETCH_JOB_OFFER_LETTER_EDIT: "JOBOfferEditall",
  HR_APPROVAL_OFFER_LETTER_EDIT: "HrApprovalDataCall",
  FETCH_ID_VERIFYING_CREATE: "IdverificationNameCreate",
  FETCH_BANK_DETAILS_EDIT: "BankEditDetails",
  FETCH_DECLARATION_FORM_CREATE: "DeclarationcreateCall",
  FETCH_DECLARATION_FORM_EDIT: "DeclarationEditCall",
  FETCH_FORM_ESI_FORM_EDIT: "ESIEditdetails",
  FETCH_FORM_ESI_FORM_CREATE: "ESICreatedetails",
  FETCH_FORM_DATA_LIKE_PRIVIOUS_DATA: "PreviousApiCallLine",
  FETCH_FORM_DATA_LIKE_DATA_FETCH_: "DatafetchCall",
  FETCH_FORM_DATA_IN_VERIFYCATION: "IdverificationNameEdit",
  FETCH_FORM_DATAS_PREVIOUS_CALL_CREATE: "PreviousCreateEmp",
  FETCH_FORM_DATAS_PREVIOUS_CALL_EDIT: "PreviousEditEmp",
  FETCH_GRIVANCE_TYPE: "grievanceTypeCall",
  FECTH_GRIEVEANCE_TYPE_FIELD_CREATE: "GrievanceCall",
  FECTH_GRIEVEANCE_TYPE_FIELD_RETRIVE: "GrievanceretrieveCall",
  FECTH_GRIEVEANCE_TYPE_FIELD_EDIT: "GrievanceEditCall",
  FECTCH_FAMLIY_FORM_FOR_FEILD_AGENT_CREATE: "FamilycreateList",
  FECTCH_FAMLIY_FORM_FOR_FEILD_AGENT_EDIT: "FamilyEditList",

  FETCH_PERFORMANCE_TYPE: "performanceTypeCall",
  FETCH_PERFORMANCE_RETRIEVE_TYPE: "performanceRetrieveTypeCall",
  FETCH_PERFORMANCE_UPDATE_TYPE: "performanceUpdateTypeCall",
  FETCH_PERFORMANCE_CREATE_TYPE: "performanceCreateTypeCall",
  FETCH_PERFORMANCE_DELETE_TYPE: "performanceDeleteTypeCall",
  FETCH_PERFORMANCE_CHILD_TYPE: "performanceChildTypeCall",
  FETCH_PERFORMANCE_CHILD_RETRIEVE_TYPE: "performanceChildRetrieveTypeCall",
  FETCH_PERFORMANCE_CHILD_UPDATE_TYPE: "performanceUpdateChildTypeCall",
  FETCH_PERFORMANCE_CHILD_CREATE_TYPE: "performanceChildCreateTypeCall",
  FETCH_PERFORMANCE_CHILD_DELETE_TYPE: "performanceChildDeleteTypeCall",
  FETCH_FORM_PUT_CALL_EDUCATION: "EducationPutCall",
  FETCH_PERFORM_FIELD_DATA: "PerformFieldAGentGet",
  FETCH_PERFORMS_FIELD_AGENT_RETRIEVE_DATAS: "PerformsFieldAgentRetrieve",
  FETCH_PERFORMS_FIELD_AGENT_EDIT_DATAS: "PerformsFieldAgentEdit",
  FETCH_PERFORMS_FIELD_AGENT_CREATE_DATAS: "PerformsFieldAgentCreate",
  FETCH_SHEET_UPLOAD_FOR__STATE_CLI_BRANCH: "ExcelSheetUploadFieldST",
  FETCH_CREATE_EMPLOYEE_SIGNS: "createEmployeeCallSign",
  FETCH_GRIEVANCE_APPROVAL_: "GrivanceDatas",
  FECTCH_GRIEVANCE_EMPLOYEE_LIST_DATA_ACTIONS: "grievanceEMpListCall",
  FECTCH_GRIEVANCE_EMPLOYEE_LIST_DATA_APPROVE: "GrievanceApproveretriveCall",
  FETCH_ATTENDANCE_REQUEST_LIST_ACTIONS_LIST: "AttendanceCall",
  FETCH_ATTENDANCE_REQUEST_LIST_ACTIONS_RETRIVE: "AttendanceRetriveCall",
  FETCH_ATTENDANCE_REQUEST_LIST_ACTIONS_APPROVE: "AttendanceApproveeCall",
  FETCH_PERFORMANCE_FIELD_BY_STAND_SEPARATE_API_CALL:
    "PerformsFieldAgentseparateRetrievename",
  FETCH_ATTENDANCE___EXPORT: "AttendanceexportCall",
  FETCH_BLACKILIST_PERSONA: "BlacklistLists",
  FETCH_BLACKLIST_DATAS_RETRIEV: "BlacklistRetrieveCall",
  FETCH_BLACKLIST_DATAS_EDIT: "BlacklistEditCall",
  FECTCH_SITE_TRANFER_GET_LIST: "SiteTransfertLists",

  FETCH_SITE_TRANSFER_ACTIONS_FOR_SITE_RETRIEVE_: "SiteTransferRetrieveCall",
  FETCH_SITE_TRANSFER_ACTIONS_FOR_SITE_APPROVE_CALL: "SiteTramsferEditCall",
  FETCH_SITE_TRANSFER_ACTIONS_FOR_CREATE: "SiteTrabsferCreateCall",
  FETCH_BLACK_LIST_ACTIONS_FOR_CREATE: "BlacklistCreateCall",
  FETCH_SEND_NOTIFICATIONS: "SendNotificationferCreateCall",
  FETCH_PDF_FORMAT_DOWNLOADS: "pdfdownloadcall",
  FETCH_GRIEVEANCE_DELTE: "GrievanceDeleteDataCall",
  FETCH_APPRAISAL_HTML_FORMAT_DATAS_POST: "AppraisalPostcall",
  FETCH_ATTENDANCES_EXPORT_GET_LIST_CALL: "AttendanceExportDatacall",
  FETCH_ADMIN_USER_LIST_ACCESS_LIST: "AdminuseraccesslistCall",

  FETCH_ADMIN_USER_ACCES_LIST_ACTIONS_POST: "adminuseraccesscrate",
  FETCH_ADMIN_USER_ACCES_LIST_ACTIONS_RETRIEVE: "adminuseraccessRETRIEVE",
  FETCH_ADMIN_USER_ACCES_LIST_ACTIONS_PUT: "adminuseraccesEDIT",
  FETCH_ADMIN_USER_LIST_ACTION_DELETE: "adminuseraccesDelETE",
  FETCH_ID_VERIFICATION_ANOTHER_KYC_EMPLOYEE_API_AS_POST:
    "idverfiyicationapidatas",
  FETCH_EXPORT_EXCEL_SHEET_FOR_EMPLOYEE_CLINET_:
    "exportexcelsheetforEMPandClien",
  FETCH_PAYSLIP_DELETE_ACTIONS: "payslipDelete",
  FETCH_BANKPASSBOOK_VERIFIED_AND_DATA_RETRIEVE:
    "UpdateDatafromChequeOrPassbook",
  FETCH_ATTENDANCE_REQUEST_GET_LIST: "AttendancezRequestSliceList",
  FETCH_ONBOARING_OTP_NUMBER_GET_DATAS: "OtpVeririedPhoneNumbers",
  FETCH_ONBOARDING_OTP_SEND_DATAS_WITH_oTPS: "OtpVeririedwithPhoneNumbers",
  FETCH_OTHER_PARTY_API_FOR_PAN_CARDS: "OtherPartyApiForPAn",
  FETCH_ACTIVE_EMPLOYEES_LIST_OUT: "ActveEmployeeList",
  FETCH_EMPLOYEE_MAKE_ACTIVE_EMPLOYEES: "ApproveEmployeeTOleft",
  FETCH_EMPLOYEE_FOR_APPROVE_EMPLOYEES_RETRIVE: "RetrieveForAproEmployeeTOleft",
  FETCH_EMPLOYEE_ACTIVE_BASED_CREATEED_ACTIONS: "ActiveEmployeeCreateData",
  FETCH_PERFORMANCE_SHEET_EXPORT_ACTIONS: "PerformanceAnswerExports",
  FETCH_APPRAISAL_EXPORTS_PRINTED_YEARdATAS: "AppraisalDatasListesUDS",
  FETCH_APPRAISAL_RETRIEVE_LIST_DATAS: "AppraisalSliceDatasss",
  FETCH_SUPERVIORS_LIST_RESPONSES_: "PutCreateSuperviorserList",
  FETCH_SUPERVISOR_LISTED_DATASS_GET_LIST: "SuperviorsSlice",
  FETCH_ATTEDANCES_LIST_MULIPLESSELECTED: "attendacemulitipleLists",

  FETCH_PERFORMANCE_HEADER_LISTED_DATAS: "PerfromancesheaderListedsicess",
  FETCH_EMPLOYEE_ATTEDANCE_RESULTS_DASHOBOARD: "EmployeeDashBoardAttedances",
  FETCH_DASHBOARD_WITH_EMPLOYEE_ATTENDACENS_FLOW:
    "DashboardwithempAttendanceCall",
  FETCH_USERDETAILS_EXPORT_DETAILS_LISTED: "UserDetailsExportSheet",
  FETCH_QUERYS_QUESTIONS_LISTED_DATAS: "QueryQuetionsDatas",
  FETCH_QUERY_ACTIONS_CRAETE_: "QueryQuestionsCreate",
  FETCH_QUERY_QUESTION_RETRIEVE: "QueryQuestionsRetrieve",
  FETCH_QUERY_QUESTIONS_EDIT: "QueryQuestionsEdit",
  FETCH_QUERY_SUBQUERY_QUESTIONS: "QuerySubQuetionsDatas",
  FETCH_SUB_QUERY_CREATED: "QuerySubQuestionsCreate",

  FETCH_QUERY_SUB_QUESTION_RETRIEVE: "QuerySubQuestionsRetrieve",
  FETCH_QUERY_SUB_QUESTIONS_EDIT: "QuerySubQuestionsEditions",
  FETCH_QUERY_QUESTIONS_DELETE: "QueryQuestionsDelete",
  FETCH_QUERY_SUB_QUESTIONS_DELETE: "QuerySUBQuestionsDelete",
  FETCH_TRACKING_RECORDS_DATAS_LIST: "TrackingrecordgetList",
  FETCH_TRACKING_SYSTEM_DATAS_RETRIEVE: "QueryTrackingrecordgetListRetrieve",
  FETCH_TRACKING_SYSTEM_DATAS_EDITIONS: "QueryTrackingrecordgetListEditions",
  FETCH_TRACING_DELETE_ACTIONS: "TrackingDelete",
  FETCH_TRACKING_CREATE_ACTIONS: "TrackingCreateSliceName",
  FECTH_FINANCE_RESPONSIVE_DATAS: "FinanceGetListedData",
  FETCH_FINANCE_EXPORT: "FinanceGetListedExportData",
  FETCH_ATTENDANCE_REPORT_DASHBOARD_ACTIONS: "AttendanceREPORTDataCall",

  FETCH_ONBOADER_DETAILS_DATA: "OnboaderDetailsListOut",
  FETCH_OTHERPARTY_AADHAR_PHONE_NUMBER_VERIFIED: "AadharOtherPartyAPIPhoneOtp",
  FETCH_OTHER_PARY_OTP_SUBMIT_FOR_AADHAR: "aadharsentSubmitthephoneotp",
  FETCH_PANCACRD_SEND_OTP: "PANCARDthephoneotp",
  FETCH_PANCARD_SUBMIT_OTP: "PANCARDtheSUBMITEDphoneotp",
  FETCH_SUPERVIRSOE_EMPLOYEE_LIST: "SuperviorsEmployeee",
  FETCH_USER_SELECT_OPTIONS_PAYLOASD_: "UserSelectedPayloadsSlice",
  FETCH_PENNY_DROP_CREATE_TOKEN_: "pennydropforBankVerify",
  FETCH_OTHER_PARTY_API_BANK_VERIFICATION: "pennydropforBank",
  FETCH_ATTENDANCE_DASHBOARD_EMPLOYEE_LIST:
    "UserSelectedDashboArdEmployeesgetdatas",
  FETCH_REPORT_DATAS_GET_DATAS: "ReportSheetData",
  FETCH_REPORT_DATAS_POST_METHOD: "ReportSheetpostmethoh",
  ///-----UDS--EMPLOYEE----
  FECTH_UDS_EMPLOYEEE_LOGIN_: "CustomUDSEMployeeLogin",
  FETCH_UDS_SEND_OTP_FOR_UDS_EMPLOYEES: "CustomUDSEMployeeSendOTP",

  //---uds---emp
  FETCH_EMPLOYEE_OTPVERIFICATIONS: "OtpVerificationsCall",
  FETCH_EMPLOYEE_SHIFT_DATAS: "ShiftDatas",
  FETCH_EMPLOYEE_ATTENDANCE_GET_LIST_DATAS: "AttenDanceCall",
  FETCH_LEAVE_TYPES: "LeaveTypeData",
  FETCH_PERMISSION_DATA: "AttenDancePermissionCall",
  FETCH_CREATE_LEAVE: "CreateLeaveCall",
  FETCH_CREATE_PERMISSION: "CreatePermissionCall",
  FETCH_ON_DUTY_DATA: "onDutyCall",
  FETCH_CREATE_ON_DUTY_DATA: "CreateOnDutyCall",
  FETCH_CALENDAR_DATA: "CalendarCall",
  FETCH_CREATE_CHECKINOUT: "CheckInOutCall",
  FETCH_PAYSLIP: "PayslipCall",
  FETCH_REIMBURSEMENT: "FetchReimbursementCall",
  FETCH_EMPLOYEEE_CHECKOUT_PUT_METHOD_CALL: "CheckInOutPutMethodCall",
  FETCH_REIMBURSEMENT: "FetchReimbursementCall",
  FECTH_ONDUTY_EMPLOYEE: "OndutyDaysemp",
  FETCH_ONDUTY_EMPLOYEEE_CREATE: "OndutyDaysempCreate",
  FETCH_PERMISSION_GET_LIST_FOR_EMPLOYEEE: "AttenDancePermissionCallEmp",
  FETC_CREATE_PERMISSION_FOR_EMPLOYEEE_: "CreatePermissionEmp",
  FETCH_NODUE_FORM_EDIT_FOR_EMP: "NodueFormEmployeeEditCalllData",
  FETCH_NODUE_FORM_RETRIEVE_FORM_POST: "NodueFormEmployeeSLiceRetrieveData",
  FETCH_NODUE_FORM_POST_DATAS_EMP: "NodueFormEmployeeSLiceData",
  FETCH_REIMBURSEMENT_CREATE_FOR_THE_EMPLOYEE: "ReimbursementDataFetchEmp",
  FETCH_GRIEVENE_GET_LIST_FOR_EMPLOYEE_: "grievenceDatasEmp",
  FETCH_GRIVENECE_TYPE_GET_LIST_FOR_EMP: "grievenceTypeDatasEmp",
  FECTH_GRIEVANCE_CREATE_FOR_EMPLOYEE: "GrievanceApplyForEmpData",
  FETCH_HELPDESK_FOR_EMPLOYEEE_: "HelpDeskDatasEMP",
  FETCH_TRACKING_PARENT_CALL_FOREMP: "TrackingParentEmp",
  FETCH_TRCKING_CATEGORY_CALL_FOR_THE_EMP: "TrackingsubCategorytEmp",
  FETCH_TRACKING_HELP_DESK_FOR_THE_EMP: "helpDeskPostForEmployeee",
  FETCH_EMP_ATTENDANCE_EMPLOYEE_GET_LIST: "EmpAttendaEmpDataGetList",

  FETCH_REGULARIZAATION_GET_LIST_FOR_EMPLOYEEE:
    "AttenDance_RegularizationCallEmp",
  FETC_CREATE_REGULARIZATIONS_FOR_EMPLOYEEE_: "CreateRegularizationEmp",
  FETCH_OVERTIME_REGUKARIZATIONS_FOR_THE_EMPLOYEEE:
    "Overtime_RegularizationCallEmp",
  FETCH_PAYSLIP_FOR_EMPLOYEEE_: "PayLipEMployeeeData",
  FETCH_FACE_VERIFICATION_STATUS: "FaceVerificationDatas",
  FETCH_RESIGNATION_STATUS_FOR_EMP: "ResignationDatasEMp",
  FETCH_RESIGNATION_RETIEVE_ING_DATAS: "ResignationEmpRetrieveEmp",
  FETCH_SIGNATURE_GET_PROFILE: "ProfileSignatureCalls",
  FETCH_SIGNATURE_PUT_PROFILE: "ProfileSignatureEditCalls",
  FETCH_SONY_EMPLOYEE_GET_LIST: "SonyEmployeeCalls",

  FETCH_OVER_ALL_REPORT_CREATE: "OverAllReportCreateCall",
  FETCH_OVER_ALL_REPORT_EDIT: "OverAllReportEditCall",
  FETCH_OVER_ALL_REPORT_GET: "OverAllReportCall",
  FETCH_OVER_ALL_REPORT_RETRIEVE: "OverAllReportRetrieveCall",
  FETCH_OVER_ALL_REPORT_EMPLOYEE_LISTED: "OverAllReportEmployeeListCall",
  FETCH_OVER_ALL_REPORT_EMPLOYEE_EXPORT: "OverAllReportEmployeeListExportCall",

  FETCH_SEND_EMAIL_EDIT_ACCESS: "sendEmailREportEditData",
  FETCH_SEND_EMAIL_RETRIEVE_GET_LIST: "sendEmailREportgetData",
  FETCH_ONBOARD_OVER_VIEW_DASHBOARD_DATAS: "DashboardOnboardOverviewCall",
  FETCH_STATE_OVERALL_STATE_LIST: "OverallStateCallData",
  FETCH_ONBOARDING_RESEND_OTP_CALL: "ResentOtpVeririedPhoneNumbers",
  FETCH_ATTENDANCE_LOCATION_DETAIL_GET_LIST: "AttendanceLocationSliceCall",
  FETCH_ATTENDANCE_LOCATION_DETAIL_CREATE_ACTION:
    "AttendanceLocationSliceCreateCall",
  FETCH_ATTENDANCE_LOCATION_DETAIL_EDIT_ACTION:
    "AttendanceLocationSliceEditionCall",
  FETCH_ATTENDANCE_LOCATION_DETAIL_DELETE_ACTION:
    "AttendanceLocationSliceDeletionCall",
  FETCH_ATTENDANCE_LOCAITON_DETAILS_RETRIEV_METHOD:
    "AttendanceLocationSliceRetrieveMethosCall",
  FETCH_SUPPORT_DOCUMENTS_FETCH: "SupportDocumentFetch",
  FETCH_SUPPORT_DOCUMENTS_EDIT: "SupportDocumentEdit",
  FETCH_MY_ONBOARDING_DATAS_GET_LISTED: "myonboardingDatas",
  FETCH_HR_ONBOARDING_DATAS_GET_LISTED: "HRonboardingDatas",
  FETCH_IN_THE_APPROVE_REQUEST_LIST: "ApproverequestDatass",
  FETCH_REGENERATOR_THE_PDF: "RegeneratePDFCalls",
  FETCH_APPROVE_REQUEST_MANAGER_LIST_: "managerapproverequestdata",
  FETCH_REPORT_DELETED_REPORT: "ReportSheetDeleted",
  FETCH_OVERTIME_REPORT_DATAS: "OvertimeSliceCall",
  FETCH_OVERTIME_APPROVE_REQEST: "OvertimeApprove",
  FECTCH_OVERALL_ONBOARDER_DATA: "OnboarderRejoindata",
  FETCH_REJOINING_FLOW_FROM_EMP: "getposttheRejoiningResponse",
  FETCH_mY_TICKET_LIST_IN_HELP_DESK: "MyTicketsSliceDatas",
  FETCH_BOTH_THE_USER_FOR_AS: "bothuserASEmployeee",
  FETCH_BLOCK_EMPLOYEEE_GET_LIST: "EmpBlockEmpDatagetStored",
  FETCH_BLOCK_EMPLOYEEE_CREATE_DATA_EMP: "EmpBlockEmpDataPosttStored",
  FETCH_SITE_TRANSFER_GET_LIST_FOR_EMP: "EmpBlockEmpSiteTransferStored",
  FETCH_ATTENDANCE_REGULARIZATION_SIGNLEANDmULIT_SELECT:
    "AttendanceRegularizationteamPostSignlemulti",
  FETCH_UNBLOCKED_EMPLOYEE_GET_LISTED_EMPLOYEES: "UnbloadedEmployeeeDataEmp",
  FETCH_CLIENT_BRANCH_LIST_API_FOR_EMP_SITE: "EmployeeClientBranchForEmpData",
  FETCH_CREATE_SITE_TRANSFER_FOR_THE_EMPLOYEE: "EmpBlockEmpSiteTransferCreate",
  FETCH_EMP_ATTENDANCE_WEB_POFILE_GET_DATAS: "EmployeeProfileGetListData",
  FETCH_EMP_ATTENDANCE_WEB_PROFILE_POST_PROFILES:
    "EmployeeProfilepostUpdateListData",
  FETCH_EMPLOYEE_UDS_WEBSITE_NO_DUE_FORM: "NodueFormFetchDatasgetFetch",
  FETCH_EMPLOYEEE_LIST_FOR_SITE_TRANSFER_: "sitetransferemployeeapidata",
  FETCH_EMPLPYEE_SKILL_ASSESSMENT_DATAS: "SkillAssessmentEmpList",

  FETCH_STATE_EMP_LIST: "StateFetchDetails",
  FETCH_REGIONS_EMP_LIST_DATAS: "RegionFetchDetails",
  FETCH_ZONE_EMP_DATAS_LIST: "ZoneFetchDetails",
  FETCH_DESIGNATION_DATA_LIST_FOR_EMP: "DesignationFetchDetails",
  FETCH_BRANCH_LIST_EMP_SITE_: "BranchFetchDetails",
  FETCH_EMP_SKILL_ASSESSMENTS_EMP_SITE_APPLY: "skillassessmentretieveempdatas",
  FETCH_EMP_SKILL_ASSESSMENT_LISTED_DETAILS_FORM_QUESTIONPAPER:
    "skillquestionpaperassessment",
  FETCH_EMP_INNERQUESTION_SKILL_ASSESSMENT_DATAS:
    "innerquestionskillassessment",
  FETCH_EMP_SKILL_ASSESSMENT_QUESTION_TYPES: "questiontypeskillassessment",
  FETCH_SKILL_ASSESSMENT_EMP_POST: "skillassessmentforapplyemppostmethod",
  FETCH_SKILL_ASSESSMENT_EMP_PUT_METHODS:
    "skillassessmentforapplyemp_put_method",

  FETCH_TICKETING_SYSTEM_CATEGORY_QUESTIONS_LIST: "TicketQuetionsDatas",

  FETCH_TICKETING_SYSTEM_CATEGORY_QUESTIONS_CREATE: "TicketQuestionsCreate",
  FETCH_TICKETING_SYSTEM_CATEGORY_QUESTIONS_RETRIEVE: "TicketQuestionsretrieve",
  FETCH_TICKING_SYSTEM_CATEGORY_QUESTION_DELETE: "TicketingQuestionsDelete",
  FETCH_TICKING_SYSTEM_CATEGORY_QUESTION_EDITIONS: "TicketQuestionsEdition",

  FETC_TICKETING_SYSTEM_SUB_CATEGORY_ACTION_LIST: "TicketSubQuetionsDatas",
  FETC_TICKETING_SYSTEM_SUB_CATEGORY_ACTION_CREATIONS:
    "TicketSubQuestionsCreate",
  FETC_TICKETING_SYSTEM_SUB_CATEGORY_ACTION_EDTION:
    "TicketingSubQuestionsEditions",
  FETC_TICKETING_SYSTEM_SUB_CATEGORY_ACTION_RETRIEVE:
    "TicketSubQuestionsRetrieve",
  FETC_TICKETING_SYSTEM_SUB_CATEGORY_ACTION_DELETE: "TickerSUBQuestionsDelete",
  FETCH_TICKETING_SYSTEM_RAISED_LIST: "TrackingrecordgetOfSystemList",
  FETCH_TICKETING_SYSTEMiN_DASHBOARDS: "Ticketingrecord_dashboard",
  FETCH_TICKETING_SYSTEM_TICKET_DETAILS: "RetrieveTickingSystemdatas",
  FETCH_TICKETING_SYSTEM_RETRIVE_COMMENTS: "commentsDatas",
  FETCH_TICKETING_SYSTEM_RETRIVE_REMARKS_RETRIEVE: "retrievetheRemarks",
  FETCH_TICKETING_SYSTEM_POSTOF_REMARKSAND_COMMENTS_POSTOF:
    "retrievetheRemarks",
  FETCH_TICKETING_SYSTEM_COMMENT_CREATEOR_REMARKS_CREATE:
    "TickeetRemarkSliceDatas",
  FETCH_TICKETING_SYSTEM_STATUS_CHANGES: "ticketstatuschanges",
  FETCH_TICKETtIME_LINE: "ticketTimeLIneSlicedata",
  FETCH_TICKETING_SYSTEM_EXPORTS: "TicketingSystemIn",
  FETCH_TICKETING_FEEDBACKS: "ticketFeedbacklistedslice",
  FETCH_CLIENT_CREATION_SCOPE_LIST: "ScopeGettheDatalist",
  FETCH_CONTACT_EDIT_PERSONS: "ContactPersonEdit",
  FETCH_LIST_OF_SCOPE_OF_CATEGORY_lISTED: "CategoryListed",
  FETCH_LIST_OF_SCOEP_OF_SUBCATEGORY_DATAS: "SubCategoryListed",
  FETCH_SUB_CATEGORY_EDIT_AND_CREATED: "SubCategoryeditandcreateScopeListed",
  FETCH_DASHBOARD_TICKETING_NEARDUEDATAS: "NearDueCallingdatas",
  FETCH_UDS_USERS_LISTED_REAMRKS: "UdsuserRemarkdssliced",
  FETCH_UDS_SUB_CATEGORY_LISTED_BRANCH_CREATIONS: "SubCategorySlicedatas",
  FETCH_INTERAL_CATEGORYLIST: "UDSQuetionsDatas",
  FETCH_INTERAL_CATEGORYCRUD: "InternalTicketCrud",
  FETCH_INTERAL_CATEGORYEDITION: "internalcategoryQuestionsEdition",
  FETCH_INTERAL_CATEGORYRETRIEVE: "internalcategoryQuestionsretrieve",
  FETCH_INTERNAL_DELET_ACTIONS: "InternalQuestionsDelete",
  FETCH_BRANCH_QR_CODE_EXPORTS: "branchqrcodes",
  FETCH_SUB_INTERNAL_GET_LIST: "InternalSubQuetionsDatas",
  FETCH_SUB_INTERNAL_GET_CRUD: "InternalSubQuestionsEditions",
  FETCH_SUB_INTERNAL_GET_CRUDCREATE: "InternalSubQuestionsCreate",
  FETCH_SUB_INTERNAL_GET_CRUDDELETE: "InternalSUBQuestionsDelete",
  FETCH_SUB_INTERNAL_GET_CRUDRETRIEVE: "InternalSubQuestionsRetrieve",
  FETCH_UNREGISTER_TICKET_LIST: "Tracking_unregisterrecordgetOfSystemList",
  FETCH_DEPARTMENT_LISTED_: "InternalSubDepartmentsDatas",
  FETCH_INTERNAL_DEPARTMENTS: "InternalDepartmentsCreate",
  FETCH_DEPARTMENT_EDIIT_ACTIONS: "InternalDepartmentsEdit",
  FETCH_DEPARTMENT_RETRIEVE_ACTIONS: "InternalDepartmentsRetrieveName",
  FETCH_INTERNAL_DEPARTMENT_DELETE: "InternalDepartmentsDelete",
  FETCH_LEVEL_USER_DEPARTMENT_LISTED: "departmentLevelUserslist",
  FETCH_DEPARTMENT_LEVEL_USERS_LISTED: "DepartmentLevelUsersListe",
  FETCH_DEPARTMENT_LEVEL_USERS_USERDELETE: "InternalDepartments_usersDelete",
  FETCH_DEPARTMENT_LEVEL_USERS_RETRIVEE: "InternalDepartments_usersRetrivee",
  FETCH_DEPARTMENT_LEVEL_USERS_EDITION: "InternalDepartments_userCrudEditions",
  FETCH_TICKET_LISTED_THE_INTERNAL_DEPARTMENTS:
    "TrackingrecordgetOfSystemListInternalDepartment",
  FETCH_TCIKET_CREATION_OF_LISTED_CRUD: "CreateinternalTicketListed",
  FETCH_TICKET_TICKET_VIEW_LISTED: "internalTicketView",
  FETCH_TICKET_LISTED_CHANGES: "internalTicketChanges",
  FETCH_TICKET_FEEDBACKGETED: "internalTicketFeedBack",
  FETCH_TCIKETING_INTERNAL_REMARKTGET_: "internalTicketRemarks",
  FETCH_TICKETING_INTERNAL_TIME_LINE: "internalTicketTimeline",
  FETCH_TICKETIGN_FEEDBACKPOST_LIEDD: "internalTicketFeedBackpost",
  FETC_INTERNAL_TICKETING_COMMANDPOST: "internalcommandticketpost",
  FETCH_INTERNAL_TICKETING_COMMANDGET: "internalcommandticketgetdata",
  FETCH_INTERNAL_TICKET_LISTED_DETPARTMENT_TICKETLISTE:
    "internalTicketDepartmentUsersNames",
  FETCH_INTERNAL_TICKETING_CRUDS: "internalTicketCRUDRemarks",
  FETCH_REMARKS_POSTFOR_INTERNALS: "internalRemarks_postvaluesName",
  FETCH_TCIKETING_INTERNAL_DASHBOARD: "TicketingInertnalDashboardCalls",
  FETCH_TCIKETING_INTERNAL_DASHBOARD_NEARDUE: "NeadueInternalTicketCalls",
  FETCH_INTERNAL_TICKETING_REJECT_REASSIGN_ASSIGN:
    "TicketReassignAssignRejectCalls",
  FETCH_CLIENT_TICKET_DETAILS_FOR_THE_INTERNAL: "TicketDetailsListedNames",
  FETCH_UNREGISTER_ASSIGNS_ACTIONS: "TicketUnregisterNameAssing",
  FETCH_TICKET_DETAILS_IN_ESCALATION_DETAILS: "ticketexcalationrecordoflist",
  FETCH_TICKET_JOURNEY_FOR_INTERNAL: "TicketJournydatasofinternlandcient",
  FETCH_TICKET_JOUREY_ACTIONS_FOR_THE_CLIENT_TICKETS: "TicketJournydatasClient",
  FETCH_TICKET_SUB_TICKET_LISTED_DATAS: "SubticketForthemanagements",
  FETCH_CLIENT_TICKET_HAS_BEEN_RAISED_TO: "ClientTicketListedDatahold",
  FETCH_CLIENT_CATEGORY_DATA_ACTIONS: "gettheClientCategoryDatas",
  FETCH_CLIENT_L_ONE_TICKET_IS_RAISING_ONE:
    "gettheClientTicketPostforLonesDatastore",
  FETCH_CLIENT_SUB_CATEGORY_LISTED_API: "gettheclientsubcategoryApidatas",
  FETCH_NOTIFICATION_GET_LISTED_: "NotificationListoutapidatahold",
  FETCH_NOTIFICATION_GET_THE_DELETE_THE_LIST: "NotificationDeleteapidatahold",
  FETCH_NEW_DASHBOARD_RECORDS_OF_DATAS_LISTED: "NewDashboardNameHolds",
  FETCH_SUB_ASSIGNED_TICKET_LISTED_DASBOARDS:
    "SubAssignTicketDasboardDataHolds",
  FETCH_ADVANCE_ATTENDANCE_DASHBOARD_OF_EMPLOYEE_COUNTS:
    "AdvanceAttendance_countsRecordsCall",
  FETCH_ADVANCE_ATTENDANCE_DASHBOARD_OF_STATE_DATAS:
    "StatesOfAdvanceAttendanceRecordsCall",
  FETCH_ADVANCE_ATTENDANCE_DASHBOARD_OF_TABLE_RECORDS:
    "EmployeeOfAdvanceAttendanceRecordsCall",
  FETCH_SECOND_STATE_OF_ADVANCE_ATTENDANCE_RECORDS:
    "advanceSecondStateSliceCall",
  FETCH_REGIONAL_MANAGER_ONBOARDDER_DATE_RECORDS: "regionalMangerRecords",
  FETCH_INTERNAL_DASHBOARD_CATEGORYDATAS: "internaltable_dashbaord",
  FETCH_CUSTOMER_SUPPORTS_DASHBOARD_DEPARTMENTDATAS: "Customer_table_dashbaord",

  FETCH_INTERNAL_DASHBOARD_STATE_BASED:
    "internal_statebased_ticketstatus_table",
  FETCH_CUSTOMER_SUPPORTS_DASHBOARD_STATEBASED:
    "Customer_table_dashbaord_statebased",

  FETCH_INTERNAL_DASHBOARD_ESCALATION_BASED: "internalEscalationsdashboard",
  FETCH_CUSTOMER_SUPPORTS_DASHBOARD_ESCALATIONSBASED:
    "ExternalEscalationsdashboard",
  FETCH_CUSTOMER_SUPPORT_TRENDING_TICKETS: "TicketTrendDashboard",
  FETCH_PERFORMANCE_MATRIX_DATAS: "PerformanceMetrics",
  FETCH_ISSUESCATEGORY_TOP_FIVE_DATAS: "IssueCategroyCustomChart",
  FETCH_HIGHESTCOUNT_OFCARDS: "CustomerSupport_stateCard",

  FETCH_STATE_CHART_RESPONSE_ACTIONS: "CustomerSupportStateChart",
  FETCH_REGION_CHART_RESPONSE_ACTIONS: "CustomerSupportRegionalChart",
  FETCH_REGIONAL_LIST_RESPONSE_ACTIONS: "CustomerSupportRegionalList",

  FETCH_REGION_CHART_RESPONSE_ACTIONS: "CustomerSupportRegionalChart",

  FETCH_ZONE_CHART_RESPONSE_ACTIONS: "CustomerSupportZoneChart",
  FETCH_ZONE_LIST_RESPONSE_ACTIONS: "CustomerSupportZoneList",

  FETCH_CLIENT_CHART_RESPONSE_ACTIONS: "CustomerSupportClientChart",
  FETCH_CLIENT_LIST_RESPONSE_ACTIONS: "CustomerSupportClientList",
  FETCH_CUSTOM_STATE_LISTEDACTIONS: "CustomerSupportStateList",
  FETCH_CATEGORY_LISTED_CUSTOM_API_CALLS: "IssueCategoryListedCustom",
  FETCH_PERFORMANCE_MATRIX_API_CALLS: "CustomPerformanceMatrix",

  FETCH_INTERNAL_PERFORMANCE_MATRIX_API_CALLS:
    "InternalCustomPerformanceMatrix",
  FETCH_INTERNAL_PERFORMANCE_DATA: "InternalPerformanceMetrics",
  FETCH_INTERNAL_CATEGORY_TOP_FIVE: "InternalIssueCategoryTopFive",
  FETCH_INTERNAL_CATEGORY_LIST: "InternalIssueCategoryList",
  FETCH_INTERNAL_STATE_CHART_DATA: "InternalSupportChartState",
  FETCH_INTERNAL_REGION_CHART_DATA: "InternalSupportRegionalChart",
  FETCH_INTERNAL_REGION_LIST_DATA: "InternalSupportRegionalList",
  FETCH_INTERNAL_ZONE_CHART_DATA: "InternalSupportZoneChart",
  FETCH_INTERNAL_ZONE_LIST_DATA: "InternalSupportZoneList",
  FETCH_INTERNAL_CLIENT_CHART_DATA: "InternalSupportClientChart",
  FETCH_INTERNAL_CLIENT_LIST_DATA: "InternalSupportClientList",
  FETCH_INTERNAL_SUPPORT_STATE_LIST: "InternalSupportStateList",
  FETCH_INTERNAL_SUPPORT_TRENDS_TICKETS: "InternalSupportTrendsTickets",

  FETCH_CUSTOMER_STATE_LISTED: "customer_geolocation_state",
  FETCH_CUSTOMER_REGION_LISTED: "customer_geolocation_regional",
  FETCH_CUSYOMER_ZONE_LISTED: "customer_geolocation_zone",
  FETCH_CUSTOMER_CLIENT_LISTEDS: "customer_geolocation_client",

  FETCH_INTERN_SUPPORT_LSITED_REGIONS: "internalsupport_regionlist",
  FETCH_INTERNAL_SUPPORT_LISTED_ZONES: "internalsupport_zone",
  FETCH_INTERNAL_SUPPORTS_LISTED_CLIENT: "internalsupport_client",

  FETCH_EMPLOYEE_EXITING_EDIT_ACTIONS: "EmployeeEditActions_exitings",
  FETCH_MASTER_DASHBOARD_LISTEDRECORDS: "masterdashboard_records",
  FETCH_MASTER_DASHBOARDCURDS_DETAILS: "masterdashboard_cruds_tocall",
  FETCH_ORGANIZATION_LISTED_FILTERS: "organization_filterlist_tocall",
  FETCH_ORGANIZATION_RM_LISTED_FILTERS: "organizationRm_filterlist_tocall",
  FETCH_CLIENT_DIVISION_LEVEL_DROPDOWN: "clientDivisionLevel_dropdown_tocall",
  FETCCH_ATTENDANCE_SUMMARY_REPORTED_DATAS:
    "EmployeeOfAdvanceAttendance_summaryRecordsCall",
  FETCH_GRIVANCE_LISTEXPORT_OPTIONS: "grievanceExportListCall",
  FEETCH_EXPORT_SALARY_ANNUAL_EXPORTACTIONS: "SalaryExportAnnualCall",
  FECTCH_EXPORT_APPOINTMENT_LETTER_EXPORTACTIONS: "AppointmentExportAnnualCall",
  FECTCH_SALARY_EXPORT_REVISION_ACTIONS: "SalaryExportletter_revisionCall",

  FECTCH_CONTRACT_RENEWAL_LETTER_ACTIONS: "Contract_Renewal_Letter_Call",
  FECTCH_SALARY_REVISION_LETTER_CHANGE_ACTIONS:
    "Salary_Revision_Letter_Change_Call",
  FETCH_WARNING_LETTER_POOR_PERFORMANCE_ACTIONS:
    "Warning_Letter_Poor_Performance_Call",

  FETCH_GENERATED_LETTER_ACTIONS: "Generate_Letter_Call",

  FETCH_WARNING_LETTER_INDISCIPLINE_ACTIONS: "Warning_Letter_Indiscipline_Call",

  FETCH_SHOW_CAUSE_ABSCONDING_ACTIONS: "Show_Cause_Absconding_Call",

  FETCH_SHOW_CAUSE_FALSE_ATTENDANCE_ACTIONS: "Show_Cause_False_Attendance_Call",

  FETCH_SHOW_CAUSE_FALSE_BILLS_SUBMISSION_ACTIONS:
    "Show_Cause_False_Bills_Submission_Call",

  FETCH_ADVANCEATTENDANCE_PARTICULAR_COUNTS:
    "AdvanceAttendance_counts_particularRecordsCall",

  FETCH_ADVANCEATTENDANCE_STATE_PARTICULAR:
    "StatesOfAdvanceAttendance_particularRecordsCall",

  FETCH_ADVANCEATTENDANCE_SECONDSTATE_PARTICULAR:
    "advanceSecondState_particularSliceCall",

  FETCH_ADVANCEATTENDANCE_EMPLOYEE_PARTICULAR:
    "EmployeeOfAdvanceAttendanceRecords_particularCall",

  FETCH_ADVANCEATTENDANCE_SUMMARY_PARTICULAR:
    "EmployeeOfAdvanceAttendanceParticular_summaryRecordsCall",

  FETCH_PRESENT_URL_API_CALLS: "signatureUpload",
  FETCH_EMPLOYEEE_RETRIEVER_URL_API_CALLS:
    "Signature_Employee_RetrieveCall_actions",
  FETCH_EMPLOYEE_E_SIGNATURE_UPDATIONS_ACTION_TRIGGER:
    "Signature_Employee_UpdatedsCall_actions",

  FETCH_USER_FORM_EXPORTS_CALLING_HERE_FORM_REQUESTED:
    "Form_ExportsUsers_RetrieveCall_actions",
  FETCH_USER_FORM_APPORVE_REQUESTED_LISED: "Form_Reports_UpdatedCall_actions",
  FECTCH_SKILL_ASSESSMENTS_DASHBAORD_COUNTS_ACTIONS:
    "Skill_Assessment_Dashboard_Count_actions",
  FETCH_SELFONBOARDING_RETRIEVE: "selfonboardingretriveslice",
  FETCH_HRMS_CONNECTIVITY_LIST_API: "hrmsConnectivityList",
  FETCH_HRMS_CONNECTIVITY_UPDATE_API: "hrmsConnectivityUpdate",
  FETCH_HRMS_CONNECTIVITY_STATUS_UPDATE_API: "hrmsConnectivityStatusUpdate",
  FETCH_SMART_CONNECT_EMPLOYEE_LIST: "smartConnectEmployeeList",
  FETCH_SMART_CONNECT_BULK_UPLOAD: "smartConnectBulkUpload",
  FETCH_LETTER_ONBOARDING_BULK_UPLOAD: "letterOnboardingBulkUpload",
  FETCH_LETTER_ONBOARDING_EMPLOYEE_LIST: "letterOnboardingEmployeeList",
  FETCH_ID_CARD_LIST_API: "idCardList",
};
